<template>
  <div
    class="
      mx-10
      flex flex-col
      justify-center
      items-center
      lg:grid lg:grid-cols-6 lg:gap-4
    "
  >
    <div class="lg:col-start-1 lg:col-end-7">
      <mill-profile />
    </div>

    <div class="lg:col-start-1 lg:col-end-7">
      <mill-table :userData="userData" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import millProfile from "../../components/Mill/millProfile.vue";
import MillTable from "../../components/Mill/millTable.vue";
export default {
  name: "Mill Overview",
  components: { millProfile, MillTable },
  data() {
    return {
      userData: [],
    };
  },
  created() {
    this.getMillData();
  },
  methods: {
    getMillData() {
      let jdata = JSON.stringify({
        regId: sessionStorage.getItem("millId"),
      });
      axios
        .post(
          ` https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/employementhubapi/index.php/api/MillData`,
          jdata
        )
        .then((res) => {
          this.userData.push(res.data.data);
        })
        .catch((err) => {
          if (err) {
            alert("Error Getting Data");
          }
        });
    },
  },
};
</script>